import Reveal from "./Reveal";

const services = [
  {
    icon: "ri-settings-4-line",
    title: "Managed IT Services",
    desc: "Proactive monitoring, maintenance, help desk support, and IT management designed to keep your business running smoothly.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Cybersecurity",
    desc: "Protect your systems, data, devices, and users with proactive security solutions and continuous threat awareness.",
  },
  {
    icon: "ri-cloud-line",
    title: "Cloud Solutions",
    desc: "Modernize your business with secure cloud infrastructure, cloud migration, collaboration tools, and scalable technology.",
  },
  {
    icon: "ri-database-2-line",
    title: "Backup & Disaster Recovery",
    desc: "Protect critical business data and maintain continuity with reliable backup and disaster recovery solutions.",
  },
  {
    icon: "ri-phone-line",
    title: "Business VoIP",
    desc: "Modern business communications with reliable VoIP phone systems designed for today's distributed workforce.",
  },
  {
    icon: "ri-git-branch-line",
    title: "Network Infrastructure",
    desc: "Design, deployment, optimization, monitoring, and maintenance of secure and reliable business networks.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "IT Consulting",
    desc: "Strategic technology guidance that aligns your IT environment with your business goals and future growth.",
  },
  {
    icon: "ri-cpu-line",
    title: "AI & Emerging Technology",
    desc: "Explore practical AI and emerging technology solutions that can improve efficiency, productivity, and competitive advantage.",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal className="max-w-2xl">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            Our Services
          </span>
          <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-3xl md:text-4xl tracking-tight">
            Complete IT Solutions for Modern Businesses
          </h2>
          <p className="mt-4 text-foreground-600 text-base md:text-lg leading-relaxed">
            From everyday technical support to long-term technology strategy, we manage the
            technology behind your business so you can focus on running it.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 80}>
              <div className="group h-full rounded-lg border border-background-200 bg-white p-6 transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 cursor-pointer">
                <span className="w-12 h-12 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-base">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}